<div class="max-w-4xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Blog</h1>
  <p class="text-gray-500 dark:text-gray-400 mb-10">
    Conseils, études de cas et actus pour les marchands.
  </p>
  <div class="grid md:grid-cols-2 gap-6">
    @for (post of posts; track post.slug) {
      <article
        class="border border-gray-100 dark:border-slate-700 rounded-2xl overflow-hidden hover:shadow-md dark:shadow-slate-900/50 transition cursor-not-allowed opacity-60"
      >
        <div
          class="h-36 bg-gradient-to-br from-purple-100 to-purple-50 flex items-center justify-center text-4xl"
        >
          {{ post.emoji }}
        </div>
        <div class="p-5">
          <span class="text-xs text-purple-600 font-medium">{{
            post.category
          }}</span>
          <h2 class="font-semibold text-gray-900 dark:text-white mt-1 mb-2">
            {{ post.title }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ post.excerpt }}</p>
          <p class="text-xs text-gray-400 mt-3">Bientôt disponible</p>
        </div>
      </article>
    }
  </div>
  <p class="text-center text-sm text-gray-400 mt-12">
    Le blog sera disponible prochainement.
    <a routerLink="/contact" class="text-purple-600 hover:underline"
      >Être notifié</a
    >
  </p>
</div>
